import { useCurrentPlan } from '@/lib/db/rxdb/hooks/entities/subscriptions'

/**
 * True when the workspace's current plan funds AI — its `aiChatTokensMonthly`
 * or `aiEmbeddingTokensMonthly` budget is unlimited (-1) or > 0. Individual and
 * Team fund AI; Free carries a 0 budget.
 *
 * This is the PLAN half of AI gating (independent of the `aiEnabled` admin
 * kill-switch). Use it to decide whether to surface AI admin tooling (usage,
 * reindex, embedding inspector) or collapse the AI settings page to just the
 * toggle + upsell. The combined "AI is usable right now" signal is
 * `useAiAvailable()` = aiEnabled AND usePlanFundsAi().
 *
 * Fails closed: absent plan or absent key → false, so AI tooling never shows
 * for a tier that doesn't explicitly fund it.
 */
export function usePlanFundsAi(): boolean {
  const plan = useCurrentPlan()
  const fundsAi = (v: number | null | undefined) =>
    v === -1 || (typeof v === 'number' && v > 0)
  return (
    !!plan &&
    (fundsAi(plan.limits?.aiChatTokensMonthly) ||
      fundsAi(plan.limits?.aiEmbeddingTokensMonthly))
  )
}
